import { useQuery } from "@tanstack/react-query"
import Loader from 'components/general/Loader'
import { useUrlFriendlyToParameters } from "helpers/urlFriendly";
import { dateToday, dateFormat } from "helpers/utils";
import { getTodayMatches } from "data/Querys";
import NotAvailable from "components/common/NotAvailable";
//Generic
import { CardsLayout as CardsLayoutGeneric } from "components/sports/glo/todayMatches/generic";

//Sports
import { CardsLayout as CardsLayoutFen } from "components/sports/glo/todayMatches/fen";
import { CardsLayout as CardsLayoutJud } from "components/sports/glo/todayMatches/jud";
import { CardsLayout as CardsLayoutTen } from "components/sports/glo/todayMatches/ten";
import { CardsLayout as CardsLayoutTte } from "components/sports/glo/todayMatches/tte";
import { CardsLayout as CardsLayoutWre } from "components/sports/glo/todayMatches/wre";
import useViewport from "components/general/useViewPort";

const getCardsLayout = (discipline) => {
    switch (discipline) {
        case 'FEN':
            return CardsLayoutFen
        case 'JUD':
            return CardsLayoutJud
        case 'TEN':
        case 'WTE':
            return CardsLayoutTen
        case 'TTE':
            return CardsLayoutTte
        case 'WRE':
            return CardsLayoutWre
        default:
            return CardsLayoutGeneric
    }
}

const TodayMatches = (props) => {
    const { mirs_competition, mirs_language, mirs_discipline, mirs_date } = useUrlFriendlyToParameters()
    const { breakPoint } = useViewport()
    const isMobile = breakPoint === 'sm' || breakPoint === 'xs'
    // load getting ready or running units
    let date = dateFormat(mirs_date) === "Invalid date" ? dateToday() : dateFormat(mirs_date)
    const { data, isError, isLoading } = useQuery(
        {
            //queryKey: ['todayMatches', mirs_competition, mirs_language, mirs_discipline, dateToday()],
            queryKey: ['todayMatches', mirs_competition, mirs_language, mirs_discipline, date],
            queryFn: getTodayMatches,
            refetchInterval: 15000,
            cacheTime: 15000,
            refetchIntervalInBackground: true,
            notifyOnChangeProps: ['data', 'error'],
        }
    );
    if (isError) { return <NotAvailable label={'LabelNoDataDailyComponent'} /> }
    if (isLoading) { return <Loader />; }

    let results = data?.filter(res => res.result)

    results = props.type === 'T'
        ? results?.filter(res => res?.eventUnit?.code?.includes('TEAM'))
        : results = props.type === 'A'
            ? results?.filter(res => !res?.eventUnit?.code?.includes('TEAM'))
            : results;

    if (!results || results.length === 0) { return <NotAvailable label={'LabelNoDataDailyComponent'} /> }

    const CardsLayout = getCardsLayout(mirs_discipline)

    return (
        <>
            <div className='mirs-page-container'>
                <CardsLayout results={results} isMobile={isMobile} />
            </div>
        </>
    );
}

export default TodayMatches;